function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSelectArrowDown = function SvgSelectArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8,
    fill: "gray"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m11.293.293-4.59 4.58-4.59-4.58-1.41 1.41 6 6 6-6z",
    style: {
      fill: "currentColor"
    }
  }));
};
export { SvgSelectArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9IiM4MDgwODAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8c3R5bGU+CiAgICAgICAgLmZpbGwtY29sb3IgewogICAgICAgICAgICBmaWxsOiBjdXJyZW50Q29sb3I7CiAgICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxwYXRoIGNsYXNzPSJmaWxsLWNvbG9yIiBkPSJNMTEuMjkzMSAwLjI5MzEyNUw2LjcwMzEyIDQuODczMTJMMi4xMTMxMiAwLjI5MzEyNUwwLjcwMzEyNSAxLjcwMzEyTDYuNzAzMTIgNy43MDMxMkwxMi43MDMxIDEuNzAzMTJMMTEuMjkzMSAwLjI5MzEyNVoiIC8+Cjwvc3ZnPgo=";